<template>
    <div>
        <vx-card title="" class="mb-4" v-if="renderComponent">
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <span>Device Type</span>
                    <span class="text-danger">*</span>
                </div>
                <div class="vx-col sm:w-3/5 w-full">
                    <v-select 
                        autocomplete
                        v-model="selected_type"
                        placeholder="Select device type"
                        :options="device_type"
                    >
                    </v-select>
                </div>
            </div> 
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <span>Device</span>
                </div>
                <div class="vx-col sm:w-3/5 w-full">
                    <v-select 
                        multiple
                        autocomplete
                        v-model="selected_devices"
                        placeholder="Select device"
                        :options="device_list"
                    >
                    </v-select>
                    <div class="w-full self-center" style="font-size: 12px">
                        Leave this option empty to select all device <br>
                    </div>
                </div>
            </div> 
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <span>Upload file</span> <span class="text-danger">*</span>
                </div>
                <div class="vx-col w-3/5">
                    <div class="vx-row flex flex-no-wrap">
                        <div class="w-full">
                            <custom-upload id="fil-upload-approve-by-id-file" style="padding-top: 1px" title="File" :file-name="document.file_name"
                                           :on-change-callback="handleFileUpload"
                                           :on-delete-callback="handleDelete"/>
                        </div>
                    </div>
                    <div class="w-full self-center" style="font-size: 12px">
                        * File must be in .zip format <br>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col w-full">
                    <span>Notes</span>
                </div>
                <div class="vx-col sm:w-3/5 w-full">
                    <vs-textarea
                        id="txt-update-notes"
                        type="text"
                        v-model="notes"
                        placeholder="Update notes"
                        class="w-full mb-4 no-icon-border"
                    />
                </div>
            </div> 
            <div class="w-full">
                <vs-button id="btn-cancel" color="warning" @click="resetForm">Reset</vs-button>
                <vs-button id="btn-submit" class="ml-4" @click.prevent="submitForm">Submit</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import CustomUpload from "@/components/upload/custom-upload"
    import Axios from "@/global/AxiosCall";
    import {url} from "@/configs/apiUrl";
    import vSelect from 'vue-select';

    export default {
        name: "DeviceUpdate",
        components: {
            CustomUpload,
            'v-select': vSelect,
        },
        data() {
            return {
                renderComponent: true,
                document: {
                    name: "file",
                    file_name: "",
                    url: ""
                },
                file: null,
                notes: null,
                device_list: [],
                device_type: [],
                selected_devices: null,
                selected_type: null,
                is_internal_user: false,
                fileInfo: {
                    name: "",
                    size: "",
                    type: "",
                },
            }
        },
        methods: {
            forceRerender() {
              // Remove my-component from the DOM
              this.renderComponent = false
              this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true
              })
            },
            resetForm() {
              this.selected_devices = null
              this.selected_type = null
              this.forceRerender()
            },
            submitForm() {
                if (this.selected_type === null) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please select device type from the list!",
                        color: "warning",
                        position: "top-right"
                    })
                }else if (this.file === null) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please select file!",
                        color: "warning",
                        position: "top-right"
                    })
                }else {
                    this.$vs.loading({
                        type: "radius"
                    })

                    let payload = new FormData()
                    let device_codes = []
                    if (this.selected_devices !== null) {
                        device_codes = this.selected_devices.map(a => a.code);
                    }
                    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
                    payload.append("file", this.file.file)
                    payload.append("notes", this.notes)
                    payload.append("device_type", this.selected_type.label)
                    payload.append("device_codes", device_codes)
                    payload.append("username", userInfo.displayName)

                    Axios.UploadDataForm(url.device_update.publish, payload)
                    .then((result) => {
                        this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "Device Update",
                            activity: "Add Update File",
                            data_before: {},
                            data_after: {
                                device_type: this.selected_type.label,
                                device_codes: device_codes,
                                username: userInfo.displayName,
                                notes: this.notes,
                                file_info: {
                                    name: this.fileInfo.name,
                                    size: this.fileInfo.size,
                                    type: this.fileInfo.type,
                                }
                            },
                        })
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: "Success",
                            text: result.message,
                            color: "success",
                            position: "top-right"
                        })
                        this.selected_devices = null
                        this.selected_type = null
                        this.notes = null
                        this.forceRerender()
                    }).catch(e => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: "Warning",
                            text: e.response.data.message,
                            color: "warning",
                            position: "top-right"
                        })
                    })
                }
            },
            handleFileUpload(file) {
                let temp = file
                this.fileInfo = {
                    name: JSON.stringify(temp.name),
                    size: JSON.stringify(parseInt(temp.size/1000)) +"KB",
                    type: JSON.stringify(temp.type)
                }
                let payload = {
                    file: file
                }

                this.file = payload
            },
            handleDelete(file, title) {
                if (title === this.document.name) {
                    this.document.file_name = ""
                    this.document.url = ""
                }

                this.file = null
            }
        },
        mounted() {
          document.getElementsByClassName("vs-con-dropdown parent-dropdown cursor-pointer")[0].id="btn-photo-profile"

          Axios.Get(url.svd.device.combo).then(resp => {
            this.device_list = []
            if (typeof resp.data !== 'undefined')
                for(let data of resp.data) {
                    data.label = data.name+' - '+data.code+' - '+data.merchant_full_name
                    this.device_list.push(data)
                }
          })

          Axios.Get(url.svd.device_type.selection).then(resp => {
            if (resp.code == 200) {
                for(let data of resp.data){
                    data.label = data.name
                    delete data.name
                    this.device_type.push(data)
                }
            } else {
                this.warning("Get device type", "Fail get device type");
            }
          })
        },
        watch: {
           
        }
    }
</script>
